import { render, staticRenderFns } from "./MealPolicyView.vue?vue&type=template&id=2b7dd0a2&"
import script from "./MealPolicyView.vue?vue&type=script&lang=js&"
export * from "./MealPolicyView.vue?vue&type=script&lang=js&"
import style0 from "./MealPolicyView.vue?vue&type=style&index=0&id=2b7dd0a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports